@if (importType() !== 'projects') {
  <div class="mb-4 max-w-xs">
    <label class="block text-body-sm-500 text-surface-700 mb-1">Lots</label>
    <p-select
      [options]="lots()"
      optionLabel="firstLabel"
      optionValue="id"
      placeholder="Select Lot"
      [filter]="true"
      [showClear]="true"
      styleClass="w-full"
      (onChange)="onLotSelected($event.value)"
    />
  </div>
}

<div class="overflow-y-auto max-h-[60vh]">
  <p-table [value]="importDeposits()" styleClass="p-datatable-sm">
    <ng-template #header>
      <tr>
        <th colspan="3" class="bg-surface-100 text-center text-body-xs-600">Deposit Details</th>
      </tr>
      <tr>
        <th class="text-body-xs-500">Type</th>
        <th class="text-body-xs-500 min-w-[180px]">Due Date</th>
        <th class="text-body-xs-500 min-w-[160px]">Amount</th>
      </tr>
    </ng-template>
    <ng-template #body let-deposit let-rowIndex="rowIndex">
      <tr>
        <td class="text-body-sm text-surface-700">{{ getDepositTypeName(deposit?.depositType?.id) }}</td>
        <td>
          <p-datepicker
            appendTo="body"
            [showIcon]="true"
            dateFormat="mm/dd/yy"
            placeholder="Due Date"
            styleClass="w-full"
            [(ngModel)]="deposit.depositDueDate"
            (ngModelChange)="onDateChange(rowIndex, $event)"
          />
        </td>
        <td>
          <p-inputNumber
            [(ngModel)]="deposit.depositAmount"
            mode="currency"
            [currency]="currencyCode()"
            locale="en-CA"
            [minFractionDigits]="2"
            styleClass="w-full"
            (ngModelChange)="onAmountChange(rowIndex, $event)"
          />
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
